<template>
  <div>
    <van-popup v-model="show" :close-on-click-overlay=false>
      <div class="popup-div0">
        <div class="pop-img">
          <img :src="count && count.img" alt />
        </div>
        <div class="div0-text" v-html="count && count.content"></div>
        <img v-if="isFrist==contentList.length-1" class="pop-img0" :src="count && count.img0" alt="">
      </div>
      <div class="pop-but">
        <van-button class="isFrist0" v-if="isFrist!='0'" @click="previousPage">上一页</van-button>
        <van-button
          :class="isFrist=='0'?'isFrist isNotFrist':'isFrist'"
          plain
          @click.prevent="nextPage"
        >{{buttonText}}</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { setLocal } from '@/utils/utils'
export default {
  data() {
    return {
      show: false,
      current: 0,
      count: null,
      isFrist: 0,
      buttonText: '下一页',
      contentList: [
        {
          content: `<p>我们提供了四种获客方式和一种组队方式，获客方式包括：获客文章、每日签到、分享产品、分享名片，组队方式包括：邀请好友。接下来我们一一介绍和学习吧。</p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>一、获客文章</p>
                    <p>A）公众号获客</p>
                    <p>1、查看文章，复制文章链接；</p>
                    <p>2、点击“集客助手-获客文章-新增”，粘贴链接、输入朋友圈配文、选择分类和勾选公开，点击上传发表成功；</p>
                    <p> 3、客户查看文章后，在“我的-销售线索-文章”查看浏览人，请主动联系他们哦。</p>
                    `,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>B）朋友圈获客</p>
                    <p>
                        1、查看文章，复制分享配文；
                    </p>
                    <p>
                        2、右上角选择“转发给朋友”或者“分享到朋友圈”，粘贴配文后“发表”完成分享；
                    </p>
                    <p>
                        3、客户查看文章后，在“我的-销售线索-文章”查看浏览人，请主动联系他们哦。
                    </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
              二、每日签到
          </p>
          <p>
              1、点击“集客助手-每日签到”，查看海报缩略图，选择分享的海报进入图片页；
          </p>
          <p>
              2、长按图片保存，将图片转发给微信好友或者朋友圈；
          </p>
          <p>
              3、客户扫码查看后，在主页右上角消息图标，可查看客户访问图片的足迹，请主动联系他们哦。
          </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
                三、分享产品
            </p>
            <p>
                1、进入“产品库”，选择产品点击“立即展业”；
            </p>
            <p>
                2、长按图片保存，将图片转发给微信好友或者朋友圈；
            </p>
            <p>
                3、客户扫码查看后，点击主页右上角消息图标或者“集客助手-我的主页-访问足迹”，可查看客户访问产品的足迹，请主动联系他们哦。
            </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
              四、分享名片
          </p>
          <p>
              1、点击“我的-个人信息”，编辑个人信息；
          </p>
          <p>
              2、点击“我的-个人名片”，点击“分享”按钮进入图片页；
          </p>
          <p>
              3、长按图片保存，将图片转发给微信好友或者朋友圈；
          </p>
          <p>
              4、客户扫码查看后，点击主页右上角消息图标，可查看客户访问名片的足迹，请主动联系他们哦。
          </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
              现在你已经掌握了所有获客操作，如果你觉得孤单，可以邀请好友组队一起开展业务哦。团队的力量更加强大呢。
          </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
              一、邀请好友<br/>
          </p>
          <p>
              1、点击“集客助手-邀请好友”，查看海报缩略图，选择海报进入图片页；
          </p>
          <p>
              2、长按图片保存，将图片转发给微信好友或者朋友圈；
          </p>
          <p>
              3、客户扫码查看后，点击主页右上角消息图标，可查看客户访问我的主页的足迹，请主动联系他们哦。
          </p>`,
          img: require('@/assets/publicImg/logo.png')
        },
        {
          content: `<p>
              现在你已经掌握了所有的获客操作和组队操作，请快速开展业务吧。祝你工作顺利哦！
          </p>`,
          img: require('@/assets/publicImg/logo.png'),
          img0: require('./img/smile.png'),
        },


      ]
    }
  },
  watch: {
    isFrist: {
        handler(newValue, oldValue) {
            if(newValue==this.contentList.length-1){
               this.buttonText='完成'
            }else if(newValue<this.contentList.length-1){
              this.buttonText='下一页'
            }
        }
    }
},
  mounted() {
    this.count = this.contentList[this.isFrist]
  },
  methods: {
    getPop(e) {
      if (e) {
        this.show = true
      }
    },
    previousPage() {
      this.isFrist--
      this.count = this.contentList[this.isFrist]
    },
    nextPage() {
      this.isFrist++
      this.count = this.contentList[this.isFrist]
      if(this.buttonText=='完成'){
        this.show=false
        setLocal("isGuide", 1);
      }
    }
  }
}
</script>
<style lang="less" scoped>
.van-popup {
  width: 225px;
  height: 290px;
  .popup-div0 {
    font-weight: 400;
    font-size: 10px;
    color: #333333;
    .pop-img {
      width: 215px;
      height: 100px;
      margin: auto;
      text-align: center;
      img {
        height: 100%;
      }
    }
    .pop-img0{
      width: 38px;
      height: 38px;
      display: block;
      margin: 15px auto auto;
    }
    .div0-text {
      max-height: 120px;
      overflow: scroll;
      padding: 10px;
    }
  }
  .pop-but {
    width: 100%;
    position: fixed;
    bottom: -1px;
    .isFrist0,.isFrist{
        width: 50%;
    }
    .isFrist {
      color: #FC6C21;
    }
    .isNotFrist {
      width: 100%;
    }
    .van-button {
      width: 50%;
      background: url("../../assets/publicImg/but.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>